export default __webpack_public_path__ + "static/footerBg-2fa58acceaae1df9adb14c70b9025773.png";